import React from "react";
// import { v4 as uuid } from "uuid";
import {
  Typography,
  // Grid,
  // AccordionSummary,
  // AccordionDetails,
  // Accordion,
  // IconButton,
  ListItem,
  ListItemButton,
  ListItemText,
  Collapse,
  // Box,
  // Container,
  // InputLabel,
} from "@common-ui/ui";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import Instruction from "./Instruction";
import Group from "./Group";
import Custom from "./CustomV2";
// import { styled } from "@mui/material/styles";
// const StyledAccordionSummary = styled((props) => (
//   <AccordionSummary
//     // expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
//     {...props}
//   />
// ))(({ theme }) => ({
//   // backgroundColor:
//   //   theme.palette.mode === "dark"
//   //     ? "rgba(255, 255, 255, .05)"
//   //     : "rgba(0, 0, 0, .03)",
//   // border: `1px solid ${theme.palette.divider}`,
//   // "&:not(:last-child)": {},
// }));
const SubSection = ({
  section,
  sectionItem,
  sectionId,
  sectionStep,
  expandedChild,
  handleChangeAccordionChild,
  rowProp,
  orgID,
  procedureStatus,
  mode,
}) => {
  const getStep = (id) => {
    return Array.from(section.steps).indexOf(id) + 1;
  };
  let subSectionStatus = procedureStatus?.sections?.find(
    (item) => item.section === sectionItem.number
  );
  const [open, setOpen] = React.useState(true);
  const handleClick = () => {
    setOpen(!open);
  };
  return (
    <>
      <>
        <ListItem
          // secondaryAction={
          //   <IconButton
          //     onClick={() => handleDeleteFile(listItem.key)}
          //     edge="end"
          //     arial-label="delete"
          //   >
          //     <Delete />
          //   </IconButton>
          // }
          sx={{ mx: -2 }}
          disablePadding
        >
          <ListItemButton onClick={handleClick}>
            <ListItemText
              primary={
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography fontWeight="700">{`${sectionItem.number} ${sectionItem.title}`}</Typography>
                  {subSectionStatus ? (
                    <Typography fontWeight="700">{`${subSectionStatus["num_completed"]}/${subSectionStatus["num_steps"]}`}</Typography>
                  ) : (
                    <Typography fontWeight="700"></Typography>
                  )}
                </div>
              }
              // secondary={listItem.type}
            />
            {open ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        </ListItem>
      </>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {Array.from(sectionItem.items).map((subSectionItem, index) => {
          return (
            <SectionItem
              section={section}
              procedureStatus={procedureStatus}
              key={subSectionItem.id}
              sectionId={sectionId}
              subSectionId={sectionItem.id}
              sectionItem={subSectionItem}
              sectionItemIndex={index}
              sectionStep={sectionStep}
              subSectionStep={getStep(sectionItem.id)}
              step={index + 1}
              rowProp={rowProp}
              orgID={orgID}
              mode={mode}
              // handleRemoveSectionItem={handleRemoveSectionItem}
            />
          );
        })}
      </Collapse>
    </>
  );
};

const SectionItem = ({
  section,
  sectionItem,
  sectionId,
  sectionItemIndex,
  sectionStep,
  step,
  expandedChild,
  handleChangeAccordionChild,
  subSectionId,
  subSectionStep,
  rowProp,
  orgID,
  procedureStatus,
  mode,
}) => {
  // return "coming Soon";
  switch (sectionItem.type) {
    case "INSTRUCTION":
      return (
        <Instruction
          section={section}
          sectionItem={sectionItem}
          sectionId={sectionId}
          subSectionId={subSectionId}
          sectionItemIndex={sectionItemIndex}
          sectionStep={sectionStep}
          subSectionStep={subSectionStep}
          step={step}
          rowProp={rowProp}
          orgID={orgID}
          mode={mode}
          // handleRemoveSectionItem={handleRemoveSectionItem}
        />
      );
    case "CUSTOM":
      return (
        <Custom
          section={section}
          sectionItem={sectionItem}
          sectionId={sectionId}
          subSectionId={subSectionId}
          sectionItemIndex={sectionItemIndex}
          sectionStep={sectionStep}
          procedureStatus={procedureStatus}
          subSectionStep={subSectionStep}
          step={step}
          rowProp={rowProp}
          orgID={orgID}
          mode={mode}
          // handleRemoveSectionItem={handleRemoveSectionItem}
        />
      );
    case "GROUP":
      return (
        <Group
          section={section}
          sectionItem={sectionItem}
          sectionId={sectionId}
          subSectionId={subSectionId}
          sectionItemIndex={sectionItemIndex}
          sectionStep={sectionStep}
          subSectionStep={subSectionStep}
          step={step}
          procedureStatus={procedureStatus}
          rowProp={rowProp}
          orgID={orgID}
          mode={mode}
          // handleRemoveSectionItem={handleRemoveSectionItem}
        />
      );
    case "SUB-SECTION":
      return (
        <SubSection
          section={section}
          sectionItem={sectionItem}
          sectionId={sectionId}
          subSectionId={subSectionId}
          sectionItemIndex={sectionItemIndex}
          sectionStep={sectionStep}
          subSectionStep={subSectionStep}
          step={step}
          procedureStatus={procedureStatus}
          rowProp={rowProp}
          orgID={orgID}
          mode={mode}
          // handleRemoveSectionItem={handleRemoveSectionItem}
          expandedChild={expandedChild}
          handleChangeAccordionChild={handleChangeAccordionChild}
        />
      );

    default:
      return "Test";
  }
};

const Section = ({
  section,
  step,
  sectionId,
  expanded,
  handleChangeAccordion,
  rowProp,
  orgID,
  procedureStatus,
  mode,
}) => {
  let sectionStatus = procedureStatus?.sections?.find(
    (item) => item.section === section.number
  );
  const [expandedChild, setExpandedChild] = React.useState(false);

  const handleChangeAccordionChild = (panel) => (event, isExpanded) => {
    setExpandedChild(isExpanded ? panel : false);
  };
  const [open, setOpen] = React.useState(true);
  const handleClick = () => {
    setOpen(!open);
  };
  return (
    <>
      <>
        <ListItem
          // secondaryAction={
          //   <IconButton
          //     onClick={() => handleDeleteFile(listItem.key)}
          //     edge="end"
          //     arial-label="delete"
          //   >
          //     <Delete />
          //   </IconButton>
          // }
          disablePadding
        >
          <ListItemButton onClick={handleClick}>
            <ListItemText
              primary={
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography fontWeight="700">{`${section.number} ${section.title}`}</Typography>
                  {sectionStatus ? (
                    <Typography fontWeight="700">{`${sectionStatus["num_completed"]}/${sectionStatus["num_steps"]}`}</Typography>
                  ) : (
                    <Typography fontWeight="700"></Typography>
                  )}
                </div>
              }
              // secondary={listItem.type}
            />
            {open ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        </ListItem>
        <Collapse in={open} timeout="auto" unmountOnExit sx={{ px: 2 }}>
          {/* <Container> */}
          {Array.from(section.items).map((sectionItem, index) => {
            return (
              <SectionItem
                rowProp={rowProp}
                orgID={orgID}
                section={section}
                procedureStatus={procedureStatus}
                key={sectionItem.id}
                sectionId={sectionId}
                sectionItem={sectionItem}
                sectionItemIndex={index}
                sectionStep={step}
                step={index + 1}
                mode={mode}
                // handleRemoveSectionItem={handleRemoveSectionItem}
                expandedChild={expandedChild}
                handleChangeAccordionChild={handleChangeAccordionChild}
              />
            );
          })}
          {/* </Container> */}
        </Collapse>
      </>
      <></>
    </>
  );
};

export { Section };
